// extracted by css-extract-rspack-plugin
export default {"checkIcon":"checkIcon-AA9Ykf"};